import { clsx } from 'clsx';
import { NavLink } from 'react-router';

import { Icon, type IconName } from '~/components/ui/icon.tsx';
import { type Permission } from '~/domain/users/models/permission.ts';

interface Props {
  userPermissions?: Permission[];
}

interface AdminSidebarLinkProps {
  icon: IconName;
  label: string;
  route: string;
  requiresPermission?: Permission;
}

function AdminSidebarLink({ icon, route, label }: AdminSidebarLinkProps) {
  return (
    <NavLink to={route} className="py-2 no-underline" title={label}>
      {({ isActive }) => (
        <div
          className={clsx('rounded fill-gray-600 p-1 text-gray-600 hover:opacity-80', {
            'fill-secondary text-secondary': isActive,
          })}
        >
          <div className="flex">
            <Icon name={icon} size="xl" />
          </div>
        </div>
      )}
    </NavLink>
  );
}

const data: AdminSidebarLinkProps[] = [
  {
    icon: 'space-dashboard-rounded',
    label: 'Dashboard',
    route: '/admin/dashboard',
    requiresPermission: 'FP.Dashboard',
  },
  { icon: 'google-store', label: 'Gyms', route: '/admin/gyms', requiresPermission: 'GymList' },
  { icon: 'group', label: 'Users', route: '/admin/users', requiresPermission: 'UserList' },
  { icon: 'receipt', label: 'Fees', route: '/admin/fees', requiresPermission: 'FP.Fees.View' },
  // ... some other links...
];

export function AdminSidebarLinks({ userPermissions }: Props) {
  const links = data
    .filter(
      (x) =>
        !x.requiresPermission || (userPermissions && userPermissions.includes(x.requiresPermission)),
    )
    .map((link) => <AdminSidebarLink key={link.label} {...link} />);

  return <div className="flex flex-col items-center overflow-y-auto pt-8">{links}</div>;
}
